export const groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {
    // eslint-disable-next-line no-param-reassign
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const transformDmaData = (data) => {
  const grouped = groupBy(data, "ST");
  return Object.keys(grouped)
    .map((key) => ({
      id: key,
      name: key,
      children: grouped[key]
        .map((child) => ({
          id: child.valueDMA.toString(),
          name: `(${child.valueDMA}) ${child.nameDMA}`,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1)),
    }))
    .sort((a, b) => (a.name > b.name ? 1 : -1));
};

export const transformZipData = (data) => {
  const dataWithState = data.map((item) => ({ ...item, ST: item.ST.trim() }));
  const grouped = groupBy(dataWithState, "ST");
  return Object.keys(grouped)
    .map((key) => {
      const innerGrouped = groupBy(grouped[key], "cityWithStateAbbr");
      return {
        id: key,
        children: Object.keys(innerGrouped)
          .map((innerKey) => ({
            id: innerKey,
            children: innerGrouped[innerKey]
              .map((child) => ({
                id: child.zip,
              }))
              .sort((a, b) => (a.id > b.id ? 1 : -1)),
          }))
          .sort((a, b) => (a.id > b.id ? 1 : -1)),
      };
    })
    .sort((a, b) => (a.id > b.id ? 1 : -1));
};
